import { persisted } from 'svelte-local-storage-store';

export const components = persisted('components', {
  formBuilder: {
    inputs: [
      {
        name: '',
        type: 'text',
        placeholder: '',
        userInput: false,
        attrs: [{ name: '', value: '' }],
      },
    ],
  },
});
